import React, {useEffect, useRef, useState} from "react";
import {
  Button,
  Col,
  Descriptions,
  Divider,
  Modal,
  QRCode,
  Row,
  Space,
  Table,
  Typography,
  Watermark,
} from "antd";
import {CallSVG, CaptivePortalSVG, LocationSVG, MailWhiteSVG} from "assets";
import {logoFullWhite, logoIconWhite, logoBill} from "assets/images/logo/";
import ReactToPrint from "react-to-print";
import {
  doiTuongOptions,
  gioiTinhOptions,
  doiTuongKCB,
} from "assets/constants/select-catagory-options";
import dayjs from "dayjs";
import {payService} from "api";
import {columns, getTodayString} from "./ModalPrintBH.config";
import {useAppSelector} from "redux/hooks";
import moment from "moment";
import "./ModalPrintBH.scss";
import {ReactComponent as PhoneSVG} from "assets/icons/phone-svg.svg";
import {ReactComponent as MailSVG} from "assets/icons/mail-svg.svg";
import {ReactComponent as InternetSVG} from "assets/icons/internet-svg.svg";
import {
  birthday2Age,
  convertIosStringToDate,
  formatToCurrencyType,
  getDateStringLocaleDetail,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import {HeaderPage, HeaderPrintForm} from "components/common";
import {FORMAT_TIME} from "types/enums";

const {Text} = Typography;

const ModalPrintBH = props => {
  const {isShowModal, handleOk, handleCancel} = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [data, setData] = useState([]);
  const idLanKham = useAppSelector(state => state.reduxCommon.id);
  const idBh = useAppSelector(state => state.common.idReceiptPrint);
  // console.log('dsadsadas', idBh);

  useEffect(() => {
    getData();
  }, [isShowModal, idLanKham]);

  const getData = async () => {
    try {
      let response = await payService
        .getDataPayPrintPerson(idLanKham)
        .then(res => {
          // console.log("data in", res);
          setThongTinIn(res.data.data);
          const newData = res.data.data.chiDinhDtoList.map(item => ({
            noiDung: item.noiDung,
            donVi: item.donVi,
            soLuong: item.soLuong,
            donGiaBV: item.donGiaBenhVien,
            thanhTien: item.thanhTien,
            bnTra: item.benhNhanTra,
            trangThaiThanhToan: item.trangThaiThanhToan,
            lyDoMienGiam: item.lyDoMienGiam,
            soTienMienGiam: item.soTienMienGiam,
          }));
          setData(newData);
        });
    } catch (err) {}
  };

  const calculateSelectedRowsTotal = dataIndex => {
    let total = 0;
    for (let i = 0; i < data.length; i++) {
      total += data[i][dataIndex] || 0;
    }
    return total;
  };

  const onPrint = async () => {
    window.print();
  };

  const capitalizeFirstLetter = str => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    // <Row className='exam-reg-bill'>
    <Modal
      centered
      open={isShowModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      width={1000}
      className="modal-custom-print-PTT-BH"
    >
      <div className="print-phieu-thu-tongBH">
        <div ref={printRef} className="print">
          <div>
            {/* <Row align={"middle"} justify={"space-between"}>
              <Col span={22}>
                <Row>
                  <Typography.Text strong style={{ fontSize: "18px" }}>
                    Bệnh viện chuyên khoa mắt Alina
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <PhoneSVG />
                      <Typography.Text>0866224883</Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <LocationSVG />
                      <Typography.Text>
                        Xuân Giang, Văn Giang, Hưng Yên
                      </Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <MailSVG />
                      <Typography.Text>contact@alinavn.com</Typography.Text>
                    </Row>
                  </Col>
                  <Col>
                    <Row style={{ gap: "8px" }} align={"middle"}>
                      <InternetSVG />
                      <Typography.Text>alinavn.com</Typography.Text>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col span={2}>
                <Row justify={"end"}>
                  <img
                    src={logoBill}
                    style={{
                      height: "32px",
                    }}
                  />
                </Row>
              </Col>
            </Row> */}
            <HeaderPrintForm />
            <Row>
              <Row justify={"center"}>
                <Typography.Title
                  style={{
                    fontWeight: "700",
                    fontSize: "30px",
                    margin: 0,
                  }}
                >
                  PHIẾU THU TIỀN
                </Typography.Title>
              </Row>
              <Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text style={{fontWeight: "800"}}>
                      {thongTinIn?.hoTen?.toUpperCase()}
                    </Typography.Text>
                    {thongTinIn?.gioiTinh
                      ? ` - ${
                          gioiTinhOptions.find(
                            it => it.value === thongTinIn?.gioiTinh
                          )?.label
                        }`
                      : ""}{" "}
                    -{" "}
                    {thongTinIn?.ngaySinh
                      ? birthday2Age(thongTinIn?.ngaySinh)
                      : ""}{" "}
                    tuổi -
                    {thongTinIn?.ngaySinh
                      ? `(SN: ${convertDateStringToDateTimezone_7(
                          thongTinIn?.ngaySinh
                        ).format(FORMAT_TIME.dayFull)})`
                      : "(SN: )"}
                    {/* {thongTinIn?.soDienThoai ? ` - ${thongTinIn.soDienThoai}` : ""} */}
                  </Col>
                  <Col>
                    <Space size={50}>
                      <Typography.Text>
                        Thời gian khám: &nbsp;
                        <Typography.Text>
                          {thongTinIn?.mgayNhapVien
                            ? dayjs(thongTinIn?.mgayNhapVien).format(
                                FORMAT_TIME.dateTime
                              )
                            : ""}
                        </Typography.Text>
                      </Typography.Text>
                      <Typography.Text>
                        Mã bệnh nhân: &nbsp;
                        <Typography.Text strong>
                          {thongTinIn?.maBenhNhan}
                        </Typography.Text>
                      </Typography.Text>
                    </Space>
                  </Col>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Typography.Text>
                      Địa chỉ: &nbsp;
                      <Typography.Text>{thongTinIn?.diaChi}</Typography.Text>
                    </Typography.Text>
                  </Col>
                  <Col
                    style={{
                      marginRight: thongTinIn?.soDienThoai ? "0px" : "75px",
                    }}
                  >
                    <Typography.Text>
                      SĐT: &nbsp;
                      <Typography.Text>
                        {thongTinIn?.soDienThoai
                          ? ` ${thongTinIn.soDienThoai}`
                          : ""}
                      </Typography.Text>
                    </Typography.Text>
                  </Col>
                </Row>
              </Row>

              <Row style={{marginTop: "10px"}}>
                <Table
                  bordered
                  columns={columns}
                  dataSource={data}
                  style={{width: "100%"}}
                  pagination={false}
                  summary={data => {
                    const column = columns;

                    return (
                      <Table.Summary.Row>
                        {column.map((col, index) => {
                          if (col.key === "noiDung") {
                            return (
                              <>
                                <Table.Summary.Cell key={index} index={index}>
                                  <Typography.Text strong>
                                    Tổng cộng:
                                  </Typography.Text>
                                </Table.Summary.Cell>
                              </>
                            );
                          }
                          if (col.key === "thanhTien" || col.key === "bnTra") {
                            return (
                              <Table.Summary.Cell
                                key={index}
                                index={index}
                                align="right"
                              >
                                {formatToCurrencyType(
                                  calculateSelectedRowsTotal(col.dataIndex)
                                )}
                              </Table.Summary.Cell>
                            );
                          }
                          return (
                            <Table.Summary.Cell index={index} key={index} />
                          );
                        })}
                      </Table.Summary.Row>
                    );
                  }}
                />
              </Row>
              <Row style={{marginTop: "10px"}}>
                <Space>
                  <Text strong>Tổng thanh toán :</Text>
                  <Typography.Text strong>
                    {formatToCurrencyType(thongTinIn?.tongThanhToan)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row>
                <Text strong>Trong đó :</Text>
              </Row>
              <Row style={{paddingLeft: "20px"}} justify={"start"}>
                <Space>
                  <Text strong> - BHYT chi trả :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thongTinIn?.baoHiemYTeChiTra)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row style={{paddingLeft: "20px"}}>
                <Space>
                  <Text strong> - BN cùng chi trả :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thongTinIn?.benhNhanCungChiTra)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row style={{paddingLeft: "20px"}}>
                <Space>
                  <Text strong> - BN chi trả :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thongTinIn?.benhNhanChiTra)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row style={{paddingLeft: "20px"}}>
                <Space>
                  <Text strong> - BN phải trả :</Text>
                  <Typography.Text strong>
                    {capitalizeFirstLetter(thongTinIn?.benhNhanPhaiTra)}
                  </Typography.Text>
                </Space>
              </Row>
              <Row style={{marginTop: "10px"}}>
                <Row justify={"end"}>
                  <Typography.Text
                    className="date-sign"
                    style={{marginRight: "15px"}}
                  >
                    {getDateStringLocaleDetail(thongTinIn?.thoiGianThanhToan)}
                  </Typography.Text>
                </Row>
                <Row justify={"space-between"}>
                  <Col>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người nộp tiền</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary">
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                  </Col>
                  <Col>
                    <Space direction="vertical" size={60}>
                      <Row>
                        <Row justify={"center"}>
                          <Typography.Text strong>Tên thu ngân</Typography.Text>
                        </Row>
                        <Row justify={"center"}>
                          <Typography.Text type="secondary">
                            (Ký và ghi rõ họ tên)
                          </Typography.Text>
                        </Row>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          {thongTinIn?.tenThuNgan
                            ? thongTinIn?.tenThuNgan
                            : localStorage.getItem("fullName")}
                        </Typography.Text>
                      </Row>
                    </Space>
                  </Col>
                </Row>
                <Row></Row>
              </Row>
              <Row justify={"center"}>
                <Typography.Text strong style={{fontSize: "12px"}}>
                  Quý khách có nhu cầu hóa đơn VAT xin vui lòng báo lễ tân/CSKH
                  0866.224.883 ngay trong ngày phát sinh dịch vụ, Bệnh viện
                  không hỗ trợ xuất hóa đơn VAT nếu nhận thông tin sau thời điểm
                  này. Xin cảm ơn
                </Typography.Text>
              </Row>
            </Row>
          </div>
        </div>
        <Row justify={"end"} style={{padding: "12px", gap: "4px"}}>
          <Space direction="horizontal">
            <Button danger type="primary" onClick={handleCancel}>
              HỦY
            </Button>
            <ReactToPrint
              trigger={() => {
                return (
                  <Button type="primary" onClick={onPrint}>
                    IN
                  </Button>
                );
              }}
              content={() => printRef.current}
              onAfterPrint={handleCancel}
              bodyClass="print-phieu-thu-tongBH"
            />
          </Space>
        </Row>
      </div>
    </Modal>
  );
};

export default ModalPrintBH;
